// extracted by mini-css-extract-plugin
module.exports = {"box":"box-mpiX0E2D","financeAndPeAd":"financeAndPeAd-3WFayMvB"};